export const orderLabel = (type) => (type === "collective" ? "Match collectif" : "Match individuel");
export const getOrderId = (order) => order?.order_id || order?.id || order?._id;
export const getUserId = (user) => user?.id || user?._id;

export const formatDate = (value) => {
  if (!value) return "Non renseigné";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Non renseigné";
  return date.toLocaleDateString("fr-FR");
};

export const getRemainingDays = (deadline) => {
  if (!deadline) return 0;
  const diff = new Date(deadline) - new Date();
  return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
};

export const toNumber = (value) => {
  const number = Number(value || 0);
  return Number.isFinite(number) ? Math.max(0, number) : 0;
};

export const totalCredits = (user) =>
  toNumber(user?.free_credits) +
  toNumber(user?.subscription_credits) +
  toNumber(user?.analysis_credits?.collective) +
  toNumber(user?.analysis_credits?.individual);

export const isPriority = (order) => Boolean(order?.priority);
export const isUrgent = (order) => order?.status !== "delivered" && (isPriority(order) || getRemainingDays(order?.deadline) <= 1);

export const extractError = (err, fallback) => err?.response?.data?.detail || err?.message || fallback;

export const normalizeStatus = (status) => {
  if (["delivered", "completed", "done", "livree", "livré", "livrée"].includes(status)) return "delivered";
  if (["in_progress", "progress", "processing", "en_cours"].includes(status)) return "in_progress";
  return "pending";
};

export const normalizeOrder = (order) => {
  const id = getOrderId(order);
  return {
    ...order,
    id,
    order_id: order.order_id || id,
    priority: Boolean(order.priority),
    status: normalizeStatus(order.status),
    analysis_link: order.analysis_link || order.delivery_link || order.result_link || "",
    analyst_message: order.analyst_message || order.delivery_message || order.message || "",
    user_name: order.user_name || [order.first_name, order.last_name].filter(Boolean).join(" ") || order.user_email || "Client",
    user_email: order.user_email || order.email || "",
    specific_request: order.specific_request || order.request || order.description || "",
  };
};

export const normalizeUser = (user) => ({
  ...user,
  id: getUserId(user),
  role: user.role || "user",
  free_credits: toNumber(user.free_credits),
  subscription_credits: toNumber(user.subscription_credits),
  analysis_credits: {
    collective: toNumber(user.analysis_credits?.collective),
    individual: toNumber(user.analysis_credits?.individual),
  },
});
